/* línkè · 真月相（2026-07-12）================================================
   星洲夜空上的那轮月亮，是**今晚真的月亮**——和铃抬头看见的窗外同一个相位。
   纯天文算法（朔望月周期），不依赖任何网络接口，离线也准。

   参考朔：2000-01-06 18:14 UTC = 一次新月（JD 2451550.1）
   朔望月：29.530588853 天
   ========================================================================= */

const SYNODIC = 29.530588853;              // 朔望月（天）
const REF_NEW_MOON = Date.UTC(2000, 0, 6, 18, 14) / 86400000; // 参考朔（天）

/** 月相位 0~1：0=新月，0.25=上弦，0.5=满月，0.75=下弦。纯函数，进单测。 */
export function moonPhase(date = new Date()) {
  const days = date.getTime() / 86400000;
  const p = ((days - REF_NEW_MOON) / SYNODIC) % 1;
  return p < 0 ? p + 1 : p;
}

/** 被照亮的比例 0~1（新月 0、满月 1）。 */
export function moonIllumination(phase) {
  return (1 - Math.cos(2 * Math.PI * phase)) / 2;
}

const NAMES = [
  '新月', '蛾眉月', '上弦月', '盈凸月',
  '满月', '亏凸月', '下弦月', '残月',
];

/** 中文月相名（八分法，就近取名）。 */
export function moonName(phase) {
  return NAMES[Math.round(phase * 8) % 8];
}

/**
 * 画月亮的 SVG 路径：被照亮那一牙的轮廓。
 *
 * 月牙 = 两段弧围成：外缘（半径 r 的半圆）+ 明暗界线（半短轴 r·|cos2πp| 的半椭圆）。
 * 界线在「上弦前」朝外鼓（月牙细）、「上弦后」朝内凹（凸月）——由 cos 的正负决定。
 * 亏月（p>0.5）亮的是另一侧 → 交给 mirror 让调用方水平翻转，几何本身复用。
 *
 * @returns {{ d: string, mirror: boolean }} 纯函数，进单测。
 */
export function moonPath(phase, r = 12) {
  const x = Math.cos(2 * Math.PI * phase); // +1 新月 → 0 半月 → -1 满月
  // 抹掉浮点渣：半月时 cos 会给出 7.3e-16 这种数，直接塞进 SVG 路径又丑又脆
  const rx = Math.round(Math.abs(x) * r * 1000) / 1000;
  // 从 (0,r) 回到 (0,-r)：sweep=0 走右侧（界线外鼓=月牙），sweep=1 走左侧（内凹=凸月）
  const sweep = x > 0 ? 0 : 1;
  const d = `M 0 ${-r} A ${r} ${r} 0 0 1 0 ${r} A ${rx} ${r} 0 0 ${sweep} 0 ${-r} Z`;
  return { d, mirror: phase > 0.5 }; // 下半周=亏月，亮边在左
}
